/**
 * @packageDocumentation
 * @module f1/array
 */

export interface Initial {
  /**
   * Return a copy of `array`, without the last item.
   *
   * @public
   * @note the spread is half the speed of a simple reference
   * @function f1.initial
   * @param arr the array of values
   * @example
   *
   * ```ts
   * initial([1, 2, 3]) => [1, 2]
   * ```
   *
   */
  <T>(arr: T[]): T[];
}

/**
 * @see Initial
 */
export default <T>(array: T[]) => array.slice(0, -1);
